import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var NotFound410Exception = /*#__PURE__*/function (_Error) {
  function NotFound410Exception(postId, reason) {
    var _this;
    _classCallCheck(this, NotFound410Exception);
    _this = _callSuper(this, NotFound410Exception, ["".concat(postId, " Post not found")]);
    _defineProperty(_this, "name", "NotFound410Exception");
    _defineProperty(_this, "type", 'api error');
    _defineProperty(_this, "statusCode", 410);
    _this.trace = reason;
    return _this;
  }
  _inherits(NotFound410Exception, _Error);
  return _createClass(NotFound410Exception);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { NotFound410Exception as default };